import React, { useState, useEffect } from 'react';
import { number, func } from 'prop-types';
import CuentaPlanPagoDeudaOriginalGrid from '../CuentaPlanPagoDeudaOriginalGrid';
import { TableCustom, Loading, InputNumber, Modal } from '../../common';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest } from '../../../utils/apiweb';
import { APIS } from '../../../config/apis';
import { PLAN_PAGO_CUOTA_STATE } from '../../../consts/planPagoCuotaState';
import { getFormatNumber, precisionRound, roundTo, getDateToString } from '../../../utils/convert';


const CuentaPlanPagoModal = (props) => {

    //variables
    const entityInit = {
        tipoPlanPago: {
            id: 0,
            codigo: "",
            nombre: "",
            idTipoTributo: 0,
            convenio: "",
            condiciones: "",
            firmas: ""
        },
        planPagoDefinicion: {
            id: 0,
            idEstadoPlanPagoDefinicion: 0,
            idTipoPlanPago: 0,
            idTipoTributo: 0,
            idTasaPlanPago: 0,
            idSubTasaPlanPago: 0,
            codigo: "",
            descripcion: "",
            fechaDesde: null,
            fechaHasta: null,
            cuotaDesde: 0,
            cuotaHasta: 0,
            periodicidad: 0,
            idTipoVencimientoAnticipo: 0,
            idTipoVencimientoCuota1: 0,
            idTipoVencimientoCuotas: 0,
            idTipoAlcanceTemporal: 0,
            fechaDesdeAlcanceTemporal: null,
            fechaHastaAlcanceTemporal: null,
            mesDesdeAlcanceTemporal: 0,
            mesHastaAlcanceTemporal: 0,
            aplicaDerechosEspontaneos: false,
            aplicaCancelacionAnticipada: false,
            aplicaTotalidadDeudaAdministrativa: false,
            aplicaDeudaAdministrativa: false,
            aplicaDeudaLegal: false,
            montoDeudaAdministrativaDesde: 0,
            montoDeudaAdministrativaHasta: 0,
            montoCuotaDesde: 0,
            montoCuotaHasta: 0,
            idTipoCalculoInteres: 0,
            idViaConsolidacion: 0,
            idTipoTratamientoPagos: 0,
            idTipoTratamientoDebitoAutomatico: 0,
            idUsuarioCreacion: 0,
            fechaCreacion: null,
            tipoPlanPago: {
                id: 0,
                codigo: "",
                nombre: "",
                idTipoTributo: 0,
                convenio: "",
                condiciones: "",
                firmas: ""
            }
        },
        planPago: {
            id: 0,
            idTipoPlanPago: 0,
            idTipoTributo: 0,
            idTasaPlanPago: 0,
            idSubTasaPlanPago: 0,
            codigo: "",
            descripcion: "",
            numero: 0,
            idPlanPagoDefinicion: 0,
            idTributo: 0,
            idCuenta: 0,
            idTipoVinculoCuenta: 0,
            idVinculoCuenta: 0,
            importeNominal: 0,
            importeAccesorios: 0,
            importeCapital: 0,
            importeIntereses: 0,
            importeSellados: 0,
            importeGastosCausidicos: 0,
            importeQuita: 0,
            importeQuitaDevengar: 0,
            importePlanPago: 0,
            idUsuarioFirmante: 0,
            idUsuarioRegistro: 0,
            fechaRegistro: null,
            tipoPlanPago: {
                id: 0,
                codigo: "",
                nombre: "",
                idTipoTributo: 0,
                convenio: "",
                condiciones: "",
                firmas: ""
            }
        },
        planPagoCuotas: []
    }

    //hooks
    const [state, setState] = useState({
        idPlanPago: 0,
        entity: entityInit,
        loading: false
    });
    const [showDeudaOriginal, setShowDeudaOriginal] = useState(false);
    const [showPagadoDetalle, setShowPagadoDetalle] = useState(false);
    const [showSaldoDetalle, setShowSaldoDetalle] = useState(false);
    const [columnsPagadoDetalle, setColumnsPagadoDetalle] = useState([]);
    const [columnsSaldoDetalle, setColumnsSaldoDetalle] = useState([]);

    const mount = () => {
        if(props.idPlanPago > 0) {
            setState(prevState => {
                return {...prevState,
                    idPlanPago: props.idPlanPago
                };
            });

            FindPlanPago(props.idPlanPago);
        }
    }
    useEffect(mount, [props.idPlanPago]);

    const cellPagado = (props) =>   <div className='action'>
                                        Acumulado
                                        <div onClick={ (event) => setShowPagadoDetalle(!showPagadoDetalle) } className="link">
                                        {(showPagadoDetalle) ?
                                            <span className="material-symbols-outlined" title="Ocultar detalle de monto acumulado">check_indeterminate_small</span>
                                            :
                                            <span className="material-symbols-outlined" title="Mostrar detalle de monto acumulado">add</span>
                                            
                                        }
                                        </div>
                                    </div>
    const cellSaldo = (props) =>    <div className='action'>
                                        Saldo
                                        <div onClick={ (event) => setShowSaldoDetalle(!showSaldoDetalle) } className="link">
                                        {(showSaldoDetalle) ?
                                            <span className="material-symbols-outlined" title="Ocultar detalle de monto saldo">check_indeterminate_small</span>
                                            :
                                            <span className="material-symbols-outlined" title="Mostrar detalle de monto saldo">add</span>
                                        }
                                        </div>
                                    </div>

    useEffect(() => {
        const columns = (showPagadoDetalle) ? [
            { Header: 'Acum. cap.', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeAcumuladoCapital', width: '8%', alignCell: 'right', disableSortBy: true },
            { Header: 'Acum. int', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeAcumuladoIntereses', width: '8%', alignCell: 'right', disableSortBy: true }
        ] : [];
        setColumnsPagadoDetalle(columns);
    }, [showPagadoDetalle])

    useEffect(() => {
        const columns = (showSaldoDetalle) ? [
            { Header: 'Saldo cap.', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeSaldoCapital', width: '8%', alignCell: 'right', disableSortBy: true },
            { Header: 'Saldo int.', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeSaldoIntereses', width: '8%', alignCell: 'right', disableSortBy: true }
        ] : [];
        setColumnsSaldoDetalle(columns);
    }, [showSaldoDetalle])

    const getDescEstadoCuota = (idEstado) => {
        switch (idEstado) {
            case PLAN_PAGO_CUOTA_STATE.PENDIENTE: return "Pendiente";
            case PLAN_PAGO_CUOTA_STATE.PAGADO: return "Pago";
            case PLAN_PAGO_CUOTA_STATE.CANCELADO: return "Cancelado";
            case PLAN_PAGO_CUOTA_STATE.COMPENSADO: return "Compensado";
            default: return "";
        }
    };

    const tableColumnsCuotas = [
        { Header: 'N° Cuota', Cell: (props) => (props.value === 0) ? "Anticipo" : props.value, accessor: 'numero', width: '5%', alignCell: 'right', disableSortBy: true },
        { Header: 'Monto cuota', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeCuota', width: '8%', alignCell: 'right', disableSortBy: true },
        { Header: 'Capital', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeCapital', width: '8%', alignCell: 'right', disableSortBy: true },
        { Header: 'Intereses', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeIntereses', width: '8%', alignCell: 'right', disableSortBy: true },
        { Header: 'Sellados', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeSellados', width: '8%', alignCell: 'right', disableSortBy: true },
        { Header: cellPagado, csvHeader: 'Acumulado', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeAcumulado', width: '8%', alignCell: 'right', disableSortBy: true },
        ...columnsPagadoDetalle,
        { Header: cellSaldo, csvHeader: 'Saldo', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeSaldo', width: '8%', alignCell: 'right', disableSortBy: true },
        ...columnsSaldoDetalle,
        { Header: 'Vencimiento', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaVencimiento', width: '10%', disableSortBy: true },
        { Header: 'Estado', Cell: (props) => getDescEstadoCuota(props.value), accessor: 'idEstadoPlanPagoCuota', width: '8%', disableSortBy: true },
        { Header: 'Fecha de pago', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaPagado', width: '10%', disableSortBy: true }
    ];

    //handles


    // funciones
    function FindPlanPago(idPlanPago) {
        setState(prevState => {
        return {...prevState, loading: true};
        });

        const paramsUrl = `/${idPlanPago}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PLAN_PAGO,
            paramsUrl,
            null,
            callbackSuccessFindPlanPago,
            callbackNoSuccess,
            callbackError
        );
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindPlanPago = (response) => {
        response.json()
        .then((data) => {
            data.planPagoDefinicion.fechaDesde = new Date(data.planPagoDefinicion.fechaDesde);
            data.planPagoDefinicion.fechaHasta = new Date(data.planPagoDefinicion.fechaHasta);
            data.planPagoDefinicion.fechaDesdeAlcanceTemporal = new Date(data.planPagoDefinicion.fechaDesdeAlcanceTemporal);
            data.planPagoDefinicion.fechaHastaAlcanceTemporal = new Date(data.planPagoDefinicion.fechaHastaAlcanceTemporal);
            data.planPagoDefinicion.fechaCreacion = new Date(data.planPagoDefinicion.fechaCreacion);
            data.planPago.fechaRegistro = new Date(data.planPago.fechaRegistro);

            let importeAcumulado = 0;
            let acumCapital = 0;
            let acumIntereses = 0;
            const totalCapital = data.planPagoCuotas.reduce((total, item) => total + item.importeCapital, 0);
            const totalIntereses = data.planPagoCuotas.reduce((total, item) => total + item.importeIntereses, 0);
            data.planPago.imoprteTotal = (data.planPago.importePlanPago + data.planPago.importeSellados);
            data.planPagoCuotas.forEach((item, index) => {
                if (item.fechaVencimiento) item.fechaVencimiento = new Date(item.fechaVencimiento);
                if (item.fechaPagado) item.fechaPagado = new Date(item.fechaPagado);

                importeAcumulado += item.importeCuota;
                item.importeAcumulado = precisionRound(importeAcumulado,2,0.2);
                item.importeSaldo =  precisionRound(data.planPago.imoprteTotal - item.importeAcumulado,2,0.2);

                acumCapital += item.importeCapital;
                item.importeAcumuladoCapital = precisionRound(acumCapital,2,0.2);
                acumIntereses += item.importeIntereses;
                item.importeAcumuladoIntereses = precisionRound(acumIntereses,2,0.2);
                item.importeSaldoCapital = precisionRound(totalCapital - acumCapital,2,0.2);
                item.importeSaldoIntereses = precisionRound(totalIntereses - acumIntereses,2,0.2);
            });

            setState(prevState => {
                return {...prevState, loading: false, entity: data};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };


    return (
    <>
        <Loading visible={state.loading}></Loading>

        <Modal
            size="xl"
            allowFullscreen
            title="Detalle de plan de pago"
            onEscape={() => props.onDismiss()}
            body={(
                    <div className='row m-top-10 m-bottom-20'>
                        <div className="col-12">

                            <label className="form-label">Definición</label>
                            <div className='row form-basic'>
                                <div className="col-12 col-lg-1">
                                    <label htmlFor="numero" className="form-label">Número</label>
                                    <InputNumber
                                        name="numero"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.numero }
                                        precision={0}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-9">
                                    <label htmlFor="descripcion" className="form-label">Descripción</label>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        className="form-control"
                                        value={ `${state.entity.planPago.codigo} | ${state.entity.planPago.descripcion}` }
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="fechaRegistro" className="form-label">Fecha de generación</label>
                                    <input
                                        name="fechaRegistro"
                                        type="text"
                                        className="form-control"
                                        value={ (state.entity.planPago.fechaRegistro) ? getDateToString(state.entity.planPago.fechaRegistro, true) : '' }
                                        disabled
                                        readOnly
                                    />
                                </div>
                            </div>

                            <label className="form-label m-top-20">Valores</label>
                            <div className='row form-basic'>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="importeCapital" className="form-label">Deuda nominal</label>
                                    <InputNumber
                                        name="importeCapital"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.importeNominal }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="importeCapital" className="form-label">(+) Accesorios</label>
                                    <InputNumber
                                        name="importeCapital"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.importeAccesorios }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="importeCapital" className="form-label">Deuda actualizada</label>
                                    <InputNumber
                                        name="importeCapital"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.importeCapital }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="importeQuita" className="form-label">(-) Total quita</label>
                                    <InputNumber
                                        name="importeQuita"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.importeQuita }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="importeIntereses" className="form-label">(+) Total intereses</label>
                                    <InputNumber
                                        name="importeIntereses"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.importeIntereses }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="importeCapital" className="form-label">(+) Sellados</label>
                                    <InputNumber
                                        name="importeCapital"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.importeSellados }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                                <div className="w-100"></div>
                                <div className="col-12 col-lg-3">
                                    <label htmlFor="importePlanPago" className="form-label">Monto del plan de pagos</label>
                                    <InputNumber
                                        name="importePlanPago"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.importePlanPago }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label htmlFor="importePlanPago" className="form-label">Monto total</label>
                                    <InputNumber
                                        name="importePlanPago"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.planPago.imoprteTotal }
                                        precision={2}
                                        disabled={true}
                                    />
                                </div>
                            </div>

                            <div className='row m-top-20'>
                                <div className="col-12">
                                    <label className="form-label">Cuotas del plan de pagos</label>
                                    <TableCustom
                                        showFooter={false}
                                        showFilterGlobal={false}
                                        className={'TableCustomBase'}
                                        columns={tableColumnsCuotas}
                                        data={state.entity.planPagoCuotas}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
            )}
            footerClassName="f-align"
            footer={(<>
                    <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
                    <button className="btn btn-outline-primary float-end" style={{marginLeft: 'auto'}} onClick={() => setShowDeudaOriginal(true)}>Deuda original</button>
            </>)}
        />

        {showDeudaOriginal &&
            <CuentaPlanPagoDeudaOriginalGrid
                data={{
                    idPlanPago: state.entity.planPago.id,
                    idCuenta: state.entity.planPago.idCuenta,
                    idTipoTributo: state.entity.planPago.idTipoTributo,
                    numero: state.entity.planPago.numero
                }}
                onDismiss={() => setShowDeudaOriginal(false)}
            />
        }

    </>
    );
}

CuentaPlanPagoModal.propTypes = {
    idPlanPago: number.isRequired,
    onDismiss: func.isRequired
  };

export default CuentaPlanPagoModal;